/**
 * CodeBlock Component
 * 
 * Syntax-highlighted code block using prism-react-renderer.
 * Supports copy-to-clipboard functionality.
 */

import React, { useState } from 'react';
import { Highlight, themes } from 'prism-react-renderer';
import { BlogConfig } from '../BlogConfig';

const CodeBlock = ({ children, className, language: propLanguage }) => {
  const [copied, setCopied] = useState(false);
  
  // Extract language from className (e.g., "language-javascript" -> "javascript")
  const language = propLanguage || 
    (className ? className.replace(/language-/, '') : 'text');
  
  const code = children.trim();
  
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };
  
  const theme = themes[BlogConfig.codeTheme] || themes.github;
  
  return (
    <div className="relative group my-6 rounded-lg overflow-hidden">
      {/* Language label */}
      <div className="absolute top-0 left-0 px-3 py-1 text-xs font-medium text-gray-500 bg-gray-100 rounded-br-lg z-10">
        {language}
      </div>
      
      {/* Copy button */}
      <button
        onClick={handleCopy}
        className="absolute top-2 right-2 px-3 py-1 text-xs font-medium text-gray-500 bg-white/90 hover:bg-white border border-gray-200 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10"
        aria-label="Copy code"
      >
        {copied ? 'Copied!' : 'Copy'}
      </button>
      
      <Highlight theme={theme} code={code} language={language}>
        {({ className: highlightClassName, style, tokens, getLineProps, getTokenProps }) => (
          <pre
            className={`${highlightClassName} p-4 pt-8 overflow-x-auto text-sm leading-relaxed`}
            style={{ ...style, margin: 0 }}
          >
            {tokens.map((line, i) => (
              <div key={i} {...getLineProps({ line })}>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token })} />
                ))}
              </div>
            ))}
          </pre>
        )}
      </Highlight>
    </div>
  );
};

export default CodeBlock;
